import { ServiceStoreConfig } from "./types/ServiceStoreTypes";

// Import categorized service stores
import { systemStores } from "./serviceStores/system.stores";
import { userStores } from "./serviceStores/user.stores";
import { estimatingStores } from "./serviceStores/estimating.stores";

/**
 * Main Service Store Configuration
 *
 * This demo only showcases the `@intrasync/designer` module, so the service
 * stores are limited to:
 * - Estimating: the authoritative designer service stores (sourced from the
 *   `@intrasync/designer` package) plus the manhole/estimating-only stores.
 * - System: generic infrastructure services (api-services, blob storage).
 * - User: user/auth-related services required to run the app.
 */
const baseStores: ServiceStoreConfig[] = [
  // Estimating / Designer Services
  ...estimatingStores,

  // System Services
  ...systemStores,

  // User Services
  ...userStores,
];

const serviceStores: ServiceStoreConfig[] = [...baseStores];

export default serviceStores;
